"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorAppBar = "#FFFFFF";
const colorOnAppBar = "#EF93BA";
const colorPrimary = "#EF93BA";
const colorPrimaryDarker = "#e34286";
const colorPrimaryLighter = "#fce9f1";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#FCE657";
const colorOnSecondary = "#000000";
const colorTiles = ["#EF93BA", "#EF93BA", "#EF93BA"];
exports.default = {
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
